import React from 'react';
import { Container } from 'reactstrap';
import { DashboardPageHeader, ComingSoonCard, DeptModulesGrid } from '../../Components/Common/DashboardKit';

/**
 * Shipping module landing page.
 *
 * Owner (2026-10-05): the department pages show MODULES, one card per module, the same
 * cards as General SS White (DeptLandingSections); a card shows only when the person may
 * open it. The Reports & KPI card opens the KPI hub on this department's tab.
 * The route is gated by dept.shipping in allRoutes.js.
 */
const MODULES = ["epo", "display", "app-visitors", "tasks", "kpi"];

const Shipping = () => {
    document.title = "SSW Technologies Dashboard";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <DashboardPageHeader
                        icon="ri-truck-line"
                        eyebrow="Logistics"
                        title="Shipping"
                        subtitle="Outbound shipments, packing, and carrier tracking"
                        tone="blue"
                        breadcrumb={[
                            { label: "Dashboards", to: "/" },
                            { label: "Shipping" },
                        ]}
                    />

                    <DeptModulesGrid ids={MODULES} dept="shipping" title="Shipping modules" icon="ri-truck-line" />

                    <ComingSoonCard
                        compact
                        icon="ri-truck-line"
                        title="More for Shipping later"
                        message="Ideas for later: daily outbound lists, packing slips and carrier tracking. The modules above are live today."
                        tone="info"
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Shipping;
